import styled from 'styled-components';

const TitleContainer = styled.div`
  justify-content: space-between;
  display: flex;
`;

export { TitleContainer };
